import { Controller } from "@hotwired/stimulus"

// Client-side column sort for an already-rendered table.
//
// Mark sortable headers with `data-action="click->table-sort#sort"` and the data
// rows with `data-table-sort-target="row"`. Sort value is the clicked column's
// cell `data-sort-value` (falling back to its text). Clicking toggles asc/desc
// and shows an arrow; rows are reordered in place before an optional
// `[data-table-sort-anchor]` element, so this composes with inline-search
// (which only toggles row visibility, never order).
export default class extends Controller {
  static targets = ["row"]

  sort(event) {
    const th = event.currentTarget
    const headerRow = th.parentNode
    const index = Array.from(headerRow.children).indexOf(th)

    const dir = this.sortedIndex === index && this.sortedDir === 1 ? -1 : 1
    this.sortedIndex = index
    this.sortedDir = dir

    const rows = [...this.rowTargets]
    if (rows.length === 0) return

    const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: "base" })
    rows.sort((a, b) => dir * collator.compare(this.cellValue(a, index), this.cellValue(b, index)))

    const tbody = rows[0].parentNode
    const anchor = tbody.querySelector("[data-table-sort-anchor]")
    rows.forEach((row) => tbody.insertBefore(row, anchor))

    this.updateIndicators(headerRow, th, dir)
  }

  cellValue(row, index) {
    const cell = row.children[index]
    if (!cell) return ""
    const raw = cell.dataset.sortValue ?? cell.textContent
    return (raw || "").trim()
  }

  updateIndicators(headerRow, activeTh, dir) {
    headerRow.querySelectorAll("[data-table-sort-arrow]").forEach((el) => (el.textContent = ""))
    const arrow = activeTh.querySelector("[data-table-sort-arrow]")
    if (arrow) arrow.textContent = dir === 1 ? "▲" : "▼"
  }
}
